// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetBasketRequestModel from '../../model/get-basket-request-model';
import GetBasketRequestDTO from '../dto/get-basket-request-dto';
import dtoSchema from '../schemas/get-basket-request-schema';

export default abstract class GetBasketRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetBasketRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
      this.publicBasketId = data.publicBasketId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {uuid}
  */
  publicBasketId?: string;

  static toModel(dto: DeepPartial<GetBasketRequestDTO>): GetBasketRequestModel;
  static toModel(dto: DeepPartial<GetBasketRequestDTO> | undefined | null): GetBasketRequestModel | undefined;
  static toModel(dto: DeepPartial<GetBasketRequestDTO> | undefined | null): GetBasketRequestModel | undefined {
    return dto ? new GetBasketRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetBasketRequestModel> | GetBasketRequestModel): GetBasketRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
      publicBasketId: unwrapped.publicBasketId,
    } as GetBasketRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetBasketRequestModel, can not map to GetBasketRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
